import React, { FC, memo } from 'react';

import { SOCIAL_MEDIA } from '@constants/common/menu.constants';

import useStyles from './styles.module';

interface Props {
  onClose?: () => void;
}

const SocialLinks: FC<Props> = ({ onClose }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.socialWrap}>
      {SOCIAL_MEDIA.map(({ link, icon }) => (
        <a
          href={link}
          key={link}
          onClick={onClose}
          className={classes.icon}
          target="_blank"
          rel="noopener noreferrer"
        >
          {icon}
        </a>
      ))}
    </div>
  );
};

export default memo(SocialLinks);
